<script>
import { h } from 'vue'
import LoadingIndicator from './LoadingIndicator.vue'
import Poll from './Poll.vue'
import VideoPlayer from './VideoPlayer.vue'
import UpVote from './UpVote.vue'
import CommentsModal from './CommentsModal.vue'
import CommentsLoader from './CommentsLoader.vue'
import ArticleShare from './ArticleShare.vue'
import AsyncRender from './AsyncRender.vue'
import SocialShare from './SocialShare.vue'
import TranscoderProgress from './TranscoderProgress.vue'
import VideoPlayerNew from './VideoPlayerNew.vue'

export default {
	props: {
		content: {
			type: String,
			default: '',
		},
		deviceContext: {
			type: Object,
			default: () => ({
				app: false,
				mobile: false,
				desktop: true,
			}),
		},
	},
	render() {
		const parent = this;
		const r = {
			components: {
				LoadingIndicator,
				Poll,
				VideoPlayer,
				UpVote,
				CommentsModal,
				CommentsLoader,
				ArticleShare,
				AsyncRender,
				SocialShare,
				TranscoderProgress,
				VideoPlayerNew
			},
			template: `<div class="content">${this.content || ''}</div>`,
			data() {
				return {
					device: parent.deviceContext,
				};
			},
			methods: {
				hello() {
					
				},
			},
		};
		return h(r);
	},
};
</script>
